import type { components } from "@entities/journal";
import { SectionThirdFormType } from "../types";

type SectionThreeDocUpdateRequest =
  components["schemas"]["SectionThreeDocUpdateRequest"];

type OriginalDoc = {
  id?: string;
  docId: string;
  docType: string;
};

export function buildSectionThreeUpdateDocs(
  docs: SectionThirdFormType["docs"] | undefined,
  originalDocs: OriginalDoc[],
): SectionThreeDocUpdateRequest[] {
  const created = (docs ?? [])
    .filter((doc) => doc.docId)
    .filter(
      (doc) =>
        !originalDocs.some(
          (original) =>
            original.docId === doc.docId && original.docType === doc.docType,
        ),
    )
    .map(
      (doc): SectionThreeDocUpdateRequest => ({
        docId: doc.docId,
        docType: doc.docType,
        action: "CREATE",
      }),
    );

  const deleted = originalDocs
    .filter(
      (original) =>
        !(docs ?? []).some(
          (doc) =>
            doc.docId === original.docId && doc.docType === original.docType,
        ),
    )
    .map(
      (removed): SectionThreeDocUpdateRequest => ({
        id: removed.id,
        docId: removed.docId,
        docType: removed.docType as SectionThreeDocUpdateRequest["docType"],
        action: "DELETE",
      }),
    );

  return [...created, ...deleted];
}
